module.exports = __webpack_public_path__ + "static/media/vu.6dcac246.svg";